import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=9ae68bae&scoped=true&"
import script from "./inventory.vue?vue&type=script&lang=js&"
export * from "./inventory.vue?vue&type=script&lang=js&"
import style0 from "./inventory.vue?vue&type=style&index=0&id=9ae68bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae68bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ae68bae')) {
      api.createRecord('9ae68bae', component.options)
    } else {
      api.reload('9ae68bae', component.options)
    }
    module.hot.accept("./inventory.vue?vue&type=template&id=9ae68bae&scoped=true&", function () {
      api.rerender('9ae68bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/inventory/inventory.vue"
export default component.exports